import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useEffect } from 'react';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

type Severity = "error" | "warning" | "info" | "success";
interface AlProps {
    message: String,
    severity: Severity,
    open: boolean,
    onClose: () => void
}

export default function CustomizedSnackbars({ message, severity, open, onClose }: AlProps) {
    const [openM, setOpen] = React.useState(open || false);

    useEffect(() => {
        setOpen(open);
    }, [open]);
    
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        onClose();
    };

    return (
        <Snackbar open={openM} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClose} sx={{ width: '100%' }} severity={severity || "warning"}>
                {message || 'This is an error message!'}
            </Alert>
        </Snackbar>
    );
}
